import "core-js/modules/es.array.includes.js";
import { ref } from 'vue';
import { Drawer } from 'vxe-pc-ui';
export default {
  name: 'XDrawer',
  components: {
    Drawer
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'medium',
      validator: value => ['medium', 'small', 'mini'].includes(value)
    },
    loading: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: '标题'
    },
    className: {
      type: String,
      default: ''
    },
    content: {
      type: String
    },
    showCancelButton: {
      type: Boolean,
      default: false
    },
    cancelButtonText: {
      type: String,
      default: '取消'
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    },
    confirmButtonText: {
      type: String,
      default: '确定'
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    lockView: {
      type: Boolean,
      default: true
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    mask: {
      type: Boolean,
      default: true
    },
    maskClosable: {
      type: Boolean,
      default: true
    },
    resize: {
      type: Boolean,
      default: true
    },
    escClosable: {
      type: Boolean,
      default: true
    },
    confirmClosable: {
      type: Boolean,
      default: true
    },
    cancelClosable: {
      type: Boolean,
      default: true
    },
    showClose: {
      type: Boolean,
      default: true
    },
    width: {
      type: [String, Number]
    },
    height: {
      type: [String, Number]
    },
    position: {
      type: String,
      default: 'right',
      validator: value => ['left', 'right', 'top', 'bottom'].includes(value)
    },
    zIndex: {
      type: Number
    },
    showTitleOverflow: {
      type: Boolean,
      default: true
    },
    transfer: {
      type: Boolean,
      default: false
    },
    destroyOnClose: {
      type: Boolean,
      default: true
    },
    beforeHideMethod: {
      type: Function
    }
  },
  emits: ['show', 'hide', 'confirm', 'cancel', 'close', 'resize', 'update:visible'],
  setup(props, context) {
    const drawerRef = ref();
    const handleShow = ({
      type
    }) => {
      context.emit('update:visible', true);
      context.emit('show', type);
    };
    const handleHide = ({
      type
    }) => {
      context.emit('hide', type);
      context.emit('update:visible', false);
    };
    const handleConfirm = ({
      type,
      $event
    }) => {
      context.emit('confirm', {
        type,
        $event
      });
    };
    const handleCancel = ({
      type,
      $event
    }) => {
      context.emit('cancel', {
        type,
        $event
      });
    };
    const handleClose = ({
      type,
      $event
    }) => {
      context.emit('close', {
        type,
        $event
      });
    };
    const handleResize = ({
      type,
      $event
    }) => {
      context.emit('resize', {
        type,
        $event
      });
    };
    return {
      drawerRef,
      handleShow,
      handleHide,
      handleConfirm,
      handleCancel,
      handleClose,
      handleResize
    };
  }
};